import {SiteBasics as SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes as ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import {SiteType} from 'Common/SiteType';


export function selectRoutes(site:SiteBasics)
{
	switch(site.type) {
		case SiteType.venue:	
			const settings = (new VenueSettingsFactory()).createSettings(site.key);
			const routerClass = settings.routes();
			return (new routerClass(settings.pages())).routes();

		case SiteType.artist:
			return (new ArtistRoutes()).routes();
	}
	Assert.check(false);
}

